import React from "react"
import styled from "styled-components/macro"
import {  OrderPaymentWalleyCheckout } from "@lib/types/generated/graphql-types"
import { getPaymentMethodDisplayName, getPaymentProviderDisplayName } from "helpers/getPaymentDisplayName"

import Status from "components/Ui/Status"
import { List, Item, Value, Label } from "components/Ui/List/List"

import { ReactComponent as WalleyLogo } from "images/providers/walley-logo.svg"

const Logo = styled(WalleyLogo)`
  position: absolute;
  height: 2rem;
  right: 3rem;
`

type Props = {
  orderPayment: OrderPaymentWalleyCheckout
}

const Walley = ({ orderPayment }: Props) => {
  if (!orderPayment) return null

  return (
    <List>
      <Logo />
      <Item>
        <Label>Status:</Label>
        <Value>
          <Status status={orderPayment.status.toUpperCase()} />
        </Value>
      </Item>
      <Item>
        <Label>Payment provider:</Label>
        <Value>{getPaymentProviderDisplayName(orderPayment.providerName)}</Value>
      </Item>
      <Item>
        <Label>Payment method:</Label>
        <Value>{getPaymentMethodDisplayName(orderPayment.method)}</Value>
      </Item>
      <Item>
        <Label>Payment reference:</Label>
        <Value>{orderPayment.reference}</Value>
      </Item>
      <Item>
        <Label>Purchase identifier:</Label>
        <Value>{orderPayment.purchaseIdentifier}</Value>
      </Item>
    </List>
  )
}

export default Walley
